import { render, staticRenderFns } from "./FormNoMitigation.vue?vue&type=template&id=59d12272"
import script from "./FormNoMitigation.vue?vue&type=script&lang=js"
export * from "./FormNoMitigation.vue?vue&type=script&lang=js"
import style0 from "./FormNoMitigation.vue?vue&type=style&index=0&id=59d12272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports